import { Drawer, Group, Stack, Title, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { useLocation } from 'react-router-dom';

import FieldMultiSelect from 'components/shared/form/FieldMultiSelect';
import Loader from 'components/ui/Loader';
import { withAsyncContent } from 'hocs/withAsyncContent';
import { withDefaultProps } from 'hocs/withDefaultProps';
import { userNotificationsStore } from 'stores/global/RootStore';
import { useDevices } from 'utils/devices';

import BaseList from './List';

import s from './UserNotificationsDrawer.module.scss';

const List = withAsyncContent(BaseList, {
  ComponentLoader: withDefaultProps(Loader, {
    text: null,
    fullHeight: true,
  }),
});

const UserNotificationsDrawer: React.FC = () => {
  const location = useLocation();
  const { ref, inView } = useInView();
  const { isPhone } = useDevices();
  const theme = useMantineTheme();
  const { modal, loadingStage, list, typeField, fetchNotifications, canLoadMore, onClose } = userNotificationsStore;

  React.useEffect(() => {
    onClose();
  }, [modal, location.pathname, onClose]);

  React.useEffect(() => {
    if (inView) {
      fetchNotifications();
    }
  }, [fetchNotifications, inView]);

  return (
    <Drawer.Root
      opened={modal.isOpen}
      position="right"
      onClose={modal.close}
      offset={isPhone ? 0 : theme.spacing.lg}
      radius={isPhone ? 0 : 'md'}
    >
      <Drawer.Overlay />
      <Drawer.Content>
        <Drawer.Header>
          <Stack w="100%">
            <Group>
              <Drawer.Title>
                <Title size="h2" component="span">
                  Уведомления
                </Title>
              </Drawer.Title>
              <Drawer.CloseButton />
            </Group>
            <FieldMultiSelect
              store={typeField}
              placeholder="Все категории"
              size="md"
              maxDisplayedValues={2}
              autoFocusSearch={false}
              dropdownMaxHeight={240}
            />
          </Stack>
        </Drawer.Header>
        <Drawer.Body className={s.root}>
          <List loadingStage={loadingStage} isLoaderAfterChildren isEmpty={list.isEmpty} />
          {canLoadMore && <div ref={ref} />}
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
};

export default observer(UserNotificationsDrawer);
